<template>
    <div class="weather-card">
        <div class="head">{{salon.name}}</div>
        <div class="body">
            <div class="info">
                <p class="id"><span class="bold">{{$t('general.salonID')}}:</span> {{salon.sid || $t('general.none')}}</p>
                <p><span class="bold">{{$t('general.address')}}: </span>{{salon.city}}, {{salon.address}}</p>
                <h3 v-if="weather"><span class="bold">{{$t('general.entries')}}: </span> {{salon.ins}}</h3>
            </div>
            <div class="weather" v-if="weather">
                <div class="image"><img :src="getImgUrl(weather.description)"></div>
                <div class="data">
                    <p class="city">{{salon.city}}</p>
                    <p class="temp">{{Math.round(weather.temperature)}}&#176;C</p>
                    <p class="desc">{{getDescription(weather.description)}}</p>
                </div>
            </div>
            <div class="weather placeholder" v-else><h3>{{$t('general.no-data')}}</h3></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'WeatherCard',
  props: {
    weather: {
      type: Object,
      required: false,
    },
    salon: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataA() {
      return Object.entries(this.weather).length === 0 && this.weather.constructor === Object;
    },
  },
  methods: {
    getDescription(description) {
      let desc = '01';
      if (description !== undefined) {
        desc = description.match(/^[0-9][0-9]/);
        if (desc === null) {
          desc = '01';
        }
      }
      return this.$t(`weather.${desc}`);
    },
    getImgUrl(pic) {
      let file = '01';
      if (pic !== undefined) {
        file = pic.match(/^[0-9][0-9]/);
        if (file === null) {
          file = '01';
        }
      }

      return require(`@/assets/images/weather/${file}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
    .weather-card {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: white;
        /* color: #878a94; */
        /*border: 1px solid #878A94;*/
        border-radius: 5px;
        box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);
        font-size: rem(18px);
        /*margin: 18px 0;*/
        @include media('<665px') {
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
        }

        .head {


            /* color: #878a94; */
            font-size: rem(18px);
            font-weight: 800;
            text-transform: uppercase;
            text-align: left;
            padding: 29px 26px;
            margin: 0;

        }

        .body {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid $border-gray;
            align-items: center;
            justify-content: space-between;
            @include media('<665px') {
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
            }

            .info {
                padding: 20px 40px;
                text-align: left;
                padding-right: 0;
            }

            .weather {
                // background-color: lighten(#002678, 30%);
                display: flex;
                padding: 50px 40px;
                align-items: center;
                justify-content: space-between;
                width: 60%;
                box-sizing: unset !important;
                //  background-image: url('../../assets/images/Image 2.png');
                // background-size: cover;
                // background-repeat: repeat;
                @include media('<665px') {
                    width: 100%;
                    box-sizing: border-box;
                }
                @include media('<480px') {
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                }

                p {
                    margin: 0;
                }

                .image {
                    padding: 45px;
                    background-color: rgba(0, 0, 0, 0.1);
                    border-radius: 50%;
                    box-sizing: content-box;
                    margin-right: 15px;

                    img {
                        width: 85px;
                        height: auto;
                    }
                }

                .city {
                    font-size: rem(29px);
                    font-weight: bold;
                }

                .temp {
                    font-size: rem(76px);
                }

                .desc {
                    font-size: rem(13px);
                }
            }
        }

        .bold {
            font-weight: bold;
        }
    }
</style>
